export default __webpack_public_path__ + "static/media/link1-1.f7cf89bc.png";